import { create } from "zustand";

interface LegacyMigrationState {
  /** True while migration is pending or running — gates report list queries */
  isMigrationPending: boolean;
  setMigrationPending: (pending: boolean) => void;
}

export const useLegacyMigrationStore = create<LegacyMigrationState>((set) => ({
  isMigrationPending: false,
  setMigrationPending: (pending) => set({ isMigrationPending: pending }),
}));

export const useIsMigrationPending = () =>
  useLegacyMigrationStore((s) => s.isMigrationPending);

export const useLegacyMigrationActions = () =>
  useLegacyMigrationStore((s) => ({ setMigrationPending: s.setMigrationPending }));
